import React from 'react';
import { useGame } from '../context/GameContext';

export default function EventScreen() {
  const { pendingEvent, chooseEventOption } = useGame();
  if (!pendingEvent) return null;
  const { event } = pendingEvent;
  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center px-6">
      <div className="text-xs uppercase tracking-[0.4em] text-[color:var(--text-dim)]">??? EVENT ???</div>
      <h1 className="font-display text-5xl font-black uppercase text-[color:var(--pink)] mt-2 max-w-3xl text-center">{event.title}</h1>
      <div className="mt-6 max-w-2xl text-center text-[color:var(--text)] leading-relaxed">{event.text}</div>
      <div className="mt-10 flex flex-col gap-3 w-full max-w-xl">
        {event.options.map((opt, i) => (
          <button
            key={i}
            className="brutal-btn text-lg py-4 uppercase"
            onClick={() => chooseEventOption(i)}
            data-testid={`event-option-${i}`}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
}
